// One-time warm splash dialog shown on a parent's first login when their
// WhatsApp isn't yet connected. Persists via localStorage so it never
// reappears once dismissed. The actual connection flow lives on Settings;
// this is just a friendly nudge.
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { MessageCircle, Sparkles, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PFP } from './styles';

export default function WhatsAppOnboardSplash({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(true); }}>
      <DialogContent
        className="rounded-3xl max-w-md border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white p-0 overflow-hidden"
        data-testid="whatsapp-onboard-splash"
        aria-describedby="whatsapp-onboard-splash-desc"
      >
        <div className="px-6 pt-7 pb-6">
          <DialogHeader>
            <div className="w-12 h-12 rounded-2xl bg-emerald-100 text-emerald-700 flex items-center justify-center mb-3">
              <MessageCircle className="w-6 h-6" />
            </div>
            <DialogTitle className="font-serif text-2xl text-[#2d3a2f]">
              Let PlayFirst meet you where you already are
            </DialogTitle>
            <DialogDescription
              id="whatsapp-onboard-splash-desc"
              className="text-stone-600 leading-relaxed mt-2"
            >
              Connect your WhatsApp number to get a tiny, gentle play idea right where
              you chat with your family. Daily, weekly, or just a soft monthly nudge —
              your choice. Pause anytime by replying <span className="font-medium text-emerald-700">PAUSE</span>.
            </DialogDescription>
          </DialogHeader>

          <ul className="mt-4 space-y-2 text-sm text-stone-700">
            <li className="flex items-start gap-2">
              <Sparkles className="w-4 h-4 text-emerald-600 mt-0.5 flex-shrink-0" />
              <span>One small play idea, personalised to your little one</span>
            </li>
            <li className="flex items-start gap-2">
              <Sparkles className="w-4 h-4 text-emerald-600 mt-0.5 flex-shrink-0" />
              <span>Reply <span className="font-medium">LOG</span> to capture a moment — it shapes the next idea</span>
            </li>
            <li className="flex items-start gap-2">
              <Sparkles className="w-4 h-4 text-emerald-600 mt-0.5 flex-shrink-0" />
              <span>No spam. No diagnoses. Just connection.</span>
            </li>
          </ul>

          <div className="flex flex-col-reverse sm:flex-row gap-2 mt-6">
            <button
              type="button"
              onClick={() => onClose(true)}
              className={PFP.btnGhost + ' flex-1'}
              data-testid="whatsapp-splash-later-btn"
            >
              Maybe later
            </button>
            <Link to="/parent-app/settings" className="flex-1">
              <button
                onClick={() => onClose(true)}
                className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-emerald-600 text-white font-medium hover:bg-emerald-700 transition-colors"
                data-testid="whatsapp-splash-connect-btn"
              >
                Connect WhatsApp
                <ArrowRight className="w-4 h-4" />
              </button>
            </Link>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
